import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getInformationById } from '../../../../api/information/queries/getInformationById';
import { IInformation } from '../../../../interfaces/Information.interfaces';

interface IUseGetInformationByIdQueryParams {
  informationId: string;
}

export const useGetInformationByIdQuery = ({ informationId }: IUseGetInformationByIdQueryParams) => {
  return useQuery<IInformation, AxiosError>(
    ['infomation_by_id', informationId],
    () => getInformationById({ informationId }),
    {
      enabled: Boolean(informationId),
    },
  );
};
